const kilimanjaroItinerary = {
  slug:"kilimanjaro",
  title: "Kilimanjaro Summit Trek",
  duration: "8 days",
  location: "Mount Kilimanjaro, Tanzania",
  difficulty: "Hard",
  priceRange: "$$$$ (Summit Expedition)",
  bestTime: "January–March & June–October",
  description:
    "Summit Africa’s highest peak via diverse ecosystems, from rainforest to alpine desert, ending at Uhuru Peak.",
  highlights: [
    "Mount Kilimanjaro summit (Uhuru Peak)",
    "Machame Route trek",
    "Barranco Wall climb",
    "Glacier views",
    "Celebration at summit"
  ],
  highlight360Views: [
  { label: "Mount Kilimanjaro", place: "Mount Kilimanjaro, Tanzania" },
  { label: "Uhuru Peak", place: "Uhuru Peak, Tanzania" },
  { label: "Machame Camp", place: "Machame Camp, Kilimanjaro" },
  { label: "Barranco Wall", place: "Barranco Wall, Kilimanjaro" },
  { label: "Shira Plateau", place: "Shira Plateau, Kilimanjaro" }
],

  image:
    "https://images.unsplash.com/photo-1549880338-65ddcdfd017b",

  days: [
    {
      day: 1,
      title: "Arrival in Arusha",
      places: [
        "Kilimanjaro International Airport",
        "Arusha City"
      ],
      activities: [
        "Arrival in Tanzania",
        "Hotel transfer",
        "Trek briefing and gear check"
      ],
      accommodation: "Arusha hotel",
      meals: "Dinner included"
    },
    {
      day: 2,
      title: "Machame Gate to Machame Camp",
      places: [
        "Machame Gate",
        "Machame Camp"
      ],
      activities: [
        "Drive to Machame Gate",
        "Begin trek through rainforest",
        "Reach Machame Camp"
      ],
      accommodation: "Mountain camp (tent)",
      meals: "All meals included"
    },
    {
      day: 3,
      title: "Machame Camp to Shira Camp",
      places: [
        "Shira Plateau",
        "Shira Camp"
      ],
      activities: [
        "Steep ascent out of rainforest",
        "Cross Shira Plateau",
        "Acclimatization walk"
      ],
      accommodation: "Mountain camp",
      meals: "All meals included"
    },
    {
      day: 4,
      title: "Shira Camp to Barranco Camp",
      places: [
        "Lava Tower",
        "Barranco Camp"
      ],
      activities: [
        "Climb to Lava Tower (4,630m)",
        "Descend to Barranco Camp",
        "Acclimatization day"
      ],
      accommodation: "Mountain camp",
      meals: "All meals included"
    },
    {
      day: 5,
      title: "Barranco Camp to Karanga Camp",
      places: [
        "Barranco Wall",
        "Karanga Camp"
      ],
      activities: [
        "Climb Barranco Wall",
        "Traverse alpine terrain",
        "Reach Karanga Camp"
      ],
      accommodation: "Mountain camp",
      meals: "All meals included"
    },
    {
      day: 6,
      title: "Karanga Camp to Barafu Camp",
      places: [
        "Barafu Camp"
      ],
      activities: [
        "Final acclimatization trek",
        "Early dinner",
        "Prepare for summit night"
      ],
      accommodation: "Mountain camp",
      meals: "All meals included"
    },
    {
      day: 7,
      title: "Summit Day – Uhuru Peak",
      places: [
        "Stella Point",
        "Uhuru Peak",
        "Mweka Camp"
      ],
      activities: [
        "Midnight summit push",
        "Reach Uhuru Peak (5,895m)",
        "Celebrate at summit",
        "Descend to Mweka Camp"
      ],
      accommodation: "Mountain camp",
      meals: "All meals included"
    },
    {
      day: 8,
      title: "Descent & Departure",
      places: [
        "Mweka Gate",
        "Arusha"
      ],
      activities: [
        "Final descent",
        "Certificate ceremony",
        "Transfer to Arusha",
        "Departure"
      ],
      accommodation: "N/A",
      meals: "Breakfast included"
    }
  ],

  inclusions: [
    "All park fees and permits",
    "Professional mountain guides",
    "Porters and cooks",
    "All meals during trek",
    "Camping equipment",
    "Airport transfers"
  ],

  exclusions: [
    "International flights",
    "Travel insurance",
    "Personal trekking gear",
    "Tips for guides and porters",
    "Visa fees"
  ],

  tips: [
    "Train cardio months in advance",
    "Climb slowly for acclimatization",
    "Pack thermal layers",
    "Stay hydrated",
    "Use trekking poles"
  ],

  budget: {
    flights: "$800–1,200",
    accommodation: "$150–250/night",
    food: "Included during trek",
    permits: "$800–1,200",
    transport: "$150–250",
    total: "$3,500–6,000 per person"
  }
};

export default kilimanjaroItinerary;
